import React from 'react';
import { featureCategories, onboardingFee, plans } from '../../data/pricing';
import { FeatureCell } from './FeatureCell';
const labelCell = 'sticky left-0 z-10 border-b border-gray-200 px-6 py-4 text-left align-middle';
const valueCell = 'border-b border-l border-gray-200 px-4 py-4 text-center align-middle';
export function PricingTable() {
  return <section aria-labelledby="compare-plans" className="bg-white px-4 py-20 sm:px-6 lg:px-8" data-id="element-233" data-mp="2yrzm2i0epnio">
      <h2 id="compare-plans" className="sr-only" data-id="element-234" data-mp="32ve6rlzais2g">
        Compare plans
      </h2>
      <div className="mx-auto max-w-[1440px] overflow-x-auto border border-gray-200 shadow-sm" data-id="element-235" data-mp="37t663129lggo">
        <table className="w-full min-w-[980px] table-fixed border-collapse" data-id="element-236" data-mp="3clzcdtddswuv">
          <colgroup data-id="element-237" data-mp="3hjip2oufl1kp">
            <col className="w-[28%]" data-id="element-238" data-mp="3hk0uoc2zgs5a" />
            {plans.map(plan => <col key={plan.id} className="w-[18%]" data-id="element-239" data-mp="3mkojcr3qowwc" />)}
          </colgroup>

          <thead data-id="element-240" data-mp="3qkgvtew97n6z">
            <tr data-id="element-241" data-mp="3qm1qr5mhd85d">
              <th scope="col" className={`${labelCell} bg-white px-8 py-10 font-normal`} data-id="element-242" data-mp="3qli79kh6mbp8">
                <p className="text-xl italic leading-snug text-gray-800 lg:text-2xl" data-id="element-243" data-mp="2dwfyqgw42or1">
                  Choose a plan that's right
                  <br data-id="element-244" data-mp="28y4m5yefm054" />
                  for your business.
                </p>
                <p className="mt-6 text-sm leading-relaxed text-gray-600" data-id="element-245" data-mp="23wxf61k454zi">
                  Prices shown are card price. Paying by ACH or check? Email{' '}
                  <a href="mailto:Results@GetAdROI.com" className="font-medium text-red-600 underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600" data-id="element-246" data-mp="2wlma1iukse2t">
                    Results@GetAdROI.com
                  </a>{' '}
                  for details.
                </p>
                <p className="mt-4 text-sm font-semibold text-gray-900" data-id="element-247" data-mp="3fbu99pv5mkdq">3-month minimum term.</p>
              </th>
              {plans.map(plan => <th key={plan.id} scope="col" className={`${plan.headerClass} px-4 py-10 text-center align-middle font-normal`} data-id="element-248" data-mp="3ajkmgipc60fo">
                  {plan.popular && <span className="mb-3 inline-block rounded-full bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-red-700" data-id="element-249" data-mp="yxs4gxv0vxar">
                      Most popular
                    </span>}
                  <p className={`text-xs font-semibold uppercase tracking-[0.18em] ${plan.subtleText}`} data-id="element-250" data-mp="pwu9f52kb04b">
                    {plan.tier}
                  </p>
                  <p className="mt-2 text-lg font-extrabold uppercase tracking-tight" data-id="element-251" data-mp="twcm5dk8c4w2">{plan.name}</p>
                  <p className="mt-5 text-4xl font-black tracking-tight xl:text-5xl" data-id="element-252" data-mp="g190so2zn1ll">{plan.price}</p>
                  <p className={`mt-1 text-sm ${plan.subtleText}`} data-id="element-253" data-mp="2acxmd93q62ey">per month</p>
                </th>)}
            </tr>
          </thead>

          <tbody data-id="element-254" data-mp="2fapdi0wjpki3">
            <tr data-id="element-255" data-mp="2fb8wlkxxmexp">
              <th scope="row" className={`${labelCell} bg-gray-50 text-xs font-bold uppercase tracking-[0.14em] text-gray-500`} data-id="element-256" data-mp="2f9o19t3smrys">
                What each plan is for
              </th>
              {plans.map(plan => <td key={plan.id} className={`${valueCell} text-sm leading-relaxed text-gray-600 ${plan.popular ? 'bg-red-50' : 'bg-gray-50'}`} data-id="element-257" data-mp="de86674rou36">
                  {plan.purpose}
                </td>)}
            </tr>
            <tr data-id="element-258" data-mp="hg3gg14oeht3">
              <th scope="row" className={`${labelCell} bg-white`} data-id="element-259" data-mp="hgl8smo7wbvq">
                <span className="block font-bold text-gray-900" data-id="element-260" data-mp="hi678ndnkeyv">White Glove Onboarding, One-Time</span>
                <span className="mt-1 block text-sm font-normal text-gray-500" data-id="element-261" data-mp="wazwv1mn2bh9">
                  Includes a real website build during onboarding.
                </span>
              </th>
              {plans.map(plan => <td key={plan.id} className={`${valueCell} text-lg font-bold text-gray-900 ${plan.popular ? 'bg-red-50/60' : ''}`} data-id="element-262" data-mp="2t65r5kl9mjp1">
                  {onboardingFee}
                </td>)}
            </tr>

            {featureCategories.map(category => <React.Fragment key={category.title} data-id="element-263" data-mp="1p9lkxutk9a25">
                <tr data-id="element-264" data-mp="1u7wq3s8wuwe1">
                  <th scope="colgroup" className="sticky left-0 z-10 bg-gray-900 px-6 py-3.5 text-left text-base font-extrabold uppercase tracking-wide text-white" data-id="element-265" data-mp="1u7n0i5rs2r8v">
                    {category.title}
                  </th>
                  {plans.map(plan => <td key={plan.id} className={`${plan.bandClass} px-4 py-2.5 text-center`} aria-hidden="true" data-id="element-266" data-mp="1aiw52f55n6ry">
                      <span className="block text-[11px] font-bold uppercase tracking-[0.14em]" data-id="element-267" data-mp="1f9ckg4sjd2gy">{plan.name}</span>
                      <span className="text-sm font-extrabold" data-id="element-268" data-mp="ishwmyfwumno">
                        {plan.price}
                        <span className={`text-xs font-medium ${plan.subtleText}`} data-id="element-269" data-mp="msi8qcfjelrk">/mo</span>
                      </span>
                    </td>)}
                </tr>
                {category.features.map(feature => <tr key={feature.name} data-id="element-270" data-mp="abh7fp6dz0yb">
                    <th scope="row" className={`${labelCell} bg-white font-normal`} data-id="element-271" data-mp="68ky6p2qkh71">
                      <span className="block text-sm font-semibold text-gray-900" data-id="element-272" data-mp="19zwel7u5pgh">{feature.name}</span>
                      {feature.note && <span className="mt-0.5 block text-xs text-gray-500" data-id="element-273" data-mp="3sgu77asce8ar">{feature.note}</span>}
                    </th>
                    {plans.map(plan => <td key={plan.id} className={`${valueCell} ${plan.popular ? 'bg-red-50/60' : ''}`} data-id="element-274" data-mp="3nnrc2y7x2qsg">
                        <FeatureCell value={feature.values[plan.id]} data-id="element-275" data-mp="3eow8zv065wtd" />
                      </td>)}
                  </tr>)}
              </React.Fragment>)}

            <tr data-id="element-276" data-mp="34qqa7m9nt6sq">
              <th scope="row" className="sticky left-0 z-10 bg-white px-6 py-8 text-left" data-id="element-277" data-mp="34q6qq14d2acl">
                <span className="block font-bold text-gray-900" data-id="element-278" data-mp="2v2kx1lxwy7f8">Not sure which fits?</span>
                <a href="tel:17022134801" className="mt-1 inline-block text-sm font-medium text-red-600 hover:text-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600" data-id="element-279" data-mp="301xji5kvhcha">
                  Call (702) 213-4801
                </a>
              </th>
              {plans.map(plan => <td key={plan.id} className={`border-l border-gray-200 px-4 py-8 text-center ${plan.popular ? 'bg-red-50/60' : ''}`} data-id="element-280" data-mp="3dudp9e55rolw">
                  <a href="mailto:Results@GetAdROI.com" className={`inline-flex w-full items-center justify-center rounded-md px-4 py-3 text-sm font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-2 ${plan.popular ? 'bg-red-600 text-white hover:bg-red-700' : 'border border-gray-300 bg-white text-gray-900 hover:border-gray-900'}`} data-id="element-281" data-mp="343slzdejhvwn">
                    Choose {plan.name}
                  </a>
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}